import PropTypes from 'prop-types';
import React from 'react';
import S from './styles.scss';
import cx from 'classnames';
import styles from 'styles/input.scss';
import { RadioGroup, RadioButton } from 'react-toolbox';

const RadioButtons = ({
  label, text, onChange, className, errors, selectedValue, radioButtons }) => {
  const errorMsg = errors.join(', ');
  const wrapperStyles = errorMsg ? cx(styles.errored, className) : className;
  const labelStyles = errorMsg ? cx(S.label, S.errorLabel) : S.label;
  const buttons = radioButtons.map(button => (
    <RadioButton label={button.label} value={button.value} key={button.label} />
    ));
  return (
    <div className={wrapperStyles}>
      <h6 className={labelStyles}>{label}</h6>
      <p className={S.text}>{text}</p>
      <RadioGroup value={selectedValue} onChange={onChange}>
        {buttons}
      </RadioGroup>

      {errorMsg &&
        <div className={styles.error}><p className={S.errorMsg}>{errorMsg}</p></div>}
    </div>
  );
};

RadioButtons.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedValue: PropTypes.string.isRequired,
  radioButtons: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  errors: PropTypes.array.isRequired,
  className: PropTypes.string,
};

RadioButtons.defaultProps = {
  label: '',
  text: '',
  errors: [],
};

export default RadioButtons;



// WEBPACK FOOTER //
// ./client/app/shared/components/RadioButtons/index.jsx